<template>
  <missing-fields-tooltip :missing-fields-list="listMissingFields">
    <v-btn
      :key="buttonkey"
      @click.once="click"
      :disabled="disabled"
      :class="{
        normal: type === 'normal',
        cancel: type === 'cancel',
        disabled: disabled,
      }"
      :loading="isLoading"
      :style="[
        defaultButtonStyling,
        buttonStyling,
        {
          height: height,
          width: width,
          maxWidth: width,
          backgroundColor: buttonColor,
          color: labelColor
        }
      ]"
    >
      <slot />
      <v-icon
        v-if="!!icon && iconSide === 'left'"
        :size="iconSize"
        :color="iconColor"
      >
        {{ icon }}
      </v-icon>
      <span
        v-if="!!label"
        class="button-label"
        :class="{ 'show-only-on-hover': showLabelOnHover }"
        :style="{ color: labelColor, 'margin-left': !!icon ? '4px' : '0' }"
      >
        {{ label }}
      </span>
      <v-icon
        v-if="!!icon && iconSide === 'right'"
        :size="iconSize"
        :color="iconColor"
      >
        {{ icon }}
      </v-icon>
    </v-btn>
  </missing-fields-tooltip>
</template>

<script>
import MissingFieldsTooltip from "@/components/_Atoms/MissingFieldsTooltip";

export default {
  name: "CustomButton",

  components: { MissingFieldsTooltip },

  props: {
    /**
     * Label showed inside the button.
     */
    label: {
      type: String,
      required: false,
    },

    /**
     * The type of the button.
     * @values normal, cancel
     */
    type: {
      type: String,
      required: false,
      validator(value) {
        return ["normal", "cancel"].indexOf(value) !== -1;
      },
      default: "normal",
    },

    /**
     * Defines if the button is disabled or not
     */
    disabled: {
      type: Boolean,
      default: false,
    },

    /**
     * If the content of the page is loading or not.
     */
    isLoading: {
      type: Boolean,
      default: false,
    },

    /**
     * List of missing fields for the user being able add
     */
    listMissingFields: {
      type: Array,
      default: () => [],
    },

    /**
     * Height of the button
     */
    height: {
      type: String,
      default: 'fit-content',
    },

    /**
     * Width of the button
     */
    width: {
      type: String,
      default: 'fit-content',
    },

    /**
     * Icon of the button
     */
    icon: {
      type: String,
      required: false,
    },

    /**
     * Color of the icon
     */
    iconColor: {
      type: String,
      required: false,
    },

    /**
     * Size of the icon
     */
    iconSize: {
      type: Number,
      default: 18,
    },

    /**
     * Indicates if the icon is to the right or left of the label
     */
    iconSide: {
      type: String,
      default: 'left',
      validator(value) {
        return ["left", "right"].indexOf(value) !== -1;
      },
    },

    /**
     * Color of the button
     */
    buttonColor: {
      type: String,
      default: '#29BDF0',
    },

    /**
     * Color of the label
     */
    labelColor: {
      type: String,
      default: '#FFFFFF'
    },

    /**
     * Styling of the button
     */
    buttonStyling: {
      type: Object,
      required: false,
    },

    /**
     * Indicates if the label is to be shown only when the button is hovered
     */
    showLabelOnHover: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      buttonkey: 0,
      defaultButtonStyling: {
        'min-width': '10px',
        'margin': '0',
        'padding': '6px 20px',
        'border-radius': '8px',
        'cursor': 'pointer',
        'font-size': '12px',
        'white-space': 'nowrap',
        'line-height': '21px',
        'box-shadow': '0 2px 4px 0 rgba(0, 0, 0, 0.09)',
        'text-transform': 'capitalize',
      },
    }
  },

  methods: {
    /**
     * Sends an event to the parent warning about the click event.
     */
    click(e) {
      this.buttonkey++;
      this.$emit("buttonClick", e);
    }
  }
};
</script>

<style scoped>
#management-button.normal {
  background: #29BDF0;
  color: white;
}

#management-button.normal.disabled {
  cursor: default;
  pointer-events: none;
  color: #bebec1;
  background-color: rgb(41, 189, 240, 0.25) !important;
}

.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: rgb(41, 189, 240, 0.25) !important;
}

.theme--light.v-btn.v-btn--disabled.v-btn--has-bg .v-icon {
  color: #FFFFFF !important;
}

#management-button.cancel {
  background: transparent;
  color: var(--primary-highlight);
  box-shadow: none;
}

.show-only-on-hover {
  display: none;
}

.theme--light.v-btn:hover .show-only-on-hover {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/newComponents/_Atoms/CustomButton.vue